import * as e from "react";
const v = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "SX_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#SX_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#E31D1C"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "SX_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#SX_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 12v12h32V12H0z",
      fill: "#2E42A5"
    }
  )), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0-2v28l20-14L0-2z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "SX_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: -2,
      width: 20,
      height: 28
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0-2v28l20-14L0-2z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#SX_svg__c)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.125 10.189c1.437 0 2.601-.938 2.601-2.095C10.726 6.938 9.562 6 8.125 6s-2.602.938-2.602 2.094c0 1.157 1.165 2.095 2.602 2.095z",
      fill: "#FBCD17"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.353 6.386c-.213 0-.364.137-.364.342v.023a.398.398 0 00-.018.116c-.003.11.037.2.123.284a.235.235 0 01.007.056c-.005-.018-.026-.033-.065-.061-.056-.041-.15-.109-.29-.251-.203-.206-.356-.286-.546-.254a.89.89 0 00-.182.057c-.108.039-.208.048-.391.013-.51-.098-1.07-.002-1.676.279l.21.453c.517-.24.974-.317 1.372-.241.274.052.464.035.654-.034a.982.982 0 01.096-.034c-.006 0-.003.005.023.029.017.016.044.042.084.083.057.058.117.11.178.158-.118.031-.112.053-.09.13.009.03.02.071.027.125.014.12-.01.181.011.21.023.033.103.026.355.015a9.909 9.909 0 00.853-.092c.14-.023.177-.031.236-.074l.052-.066a23.525 23.525 0 011.638-.183c.013 0 .013 0 .074-.013l.042-.018c.002 0 .003-.001 0 0l.123-.29-.127-.154c-.076-.023-.084-.026-.092-.026h-.004l-.017-.001h-.122c-.083 0-.148-.008-.243-.024l-.088-.017c-.39-.071-.752-.071-1.518.043a3.62 3.62 0 00-.043-.033c.123-.021.274-.036.433-.044l.15-.006h.023l-.003-.5h-.885zm-.415 1.447l.047-.01.047-.01a7.583 7.583 0 01-.028.006l-.066.014z",
      fill: "#DA610A"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.925 8.58l.08.014.081-.013c.993-.163 1.647-.144 2.026-.017.437.147.919.105 1.426-.066a9.313 9.313 0 00-.243 2.034c0 .727.14 1.314.268 1.83l.01.04c.125.505.229.923.229 1.403 0 .43-.143.656-.343.798-.23.163-.616.268-1.188.268-.806 0-1.56.217-2.254.641l-.012-.008-.01.008a4.253 4.253 0 00-2.255-.641c-.572 0-.957-.105-1.189-.268-.2-.142-.342-.368-.342-.798 0-.48.104-.898.229-1.403l.01-.04c.127-.516.268-1.103.268-1.83 0-.638-.082-1.316-.243-2.034.507.171.99.213 1.426.066.379-.127 1.032-.146 2.026.017z",
      fill: "#56C6F5",
      stroke: "#E31D1C"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.783 10.624l-.771-.686-.772.686h.229v.396l-1.2.747v1.829h-.228v.342h4v-.342h-.286v-1.829l-1.258-.783v-.36h.286z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.012 9.938l.083-.093-.083-.074-.083.074.083.093zm.771.686v.125h.329l-.246-.218-.083.093zm-1.543 0l-.083-.093-.246.218h.33v-.125zm.229 0h.125V10.5h-.125v.125zm0 .396l.066.106.059-.036v-.07h-.125zm-1.2.747l-.066-.106-.058.037v.07h.125zm0 1.829v.125h.126v-.125H6.27zm-.228 0v-.125h-.125v.125h.125zm0 .342h-.125v.125h.125v-.125zm.229 0h.125v-.125H6.27v.125zm0 0h-.125v.126h.125v-.125zm3.485 0v.126h.125v-.125h-.125zm0 0v-.125H9.63v.125h.125zm.286 0v.125h.125v-.125h-.125zm0-.342h.125v-.125h-.125v.125zm-.286 0H9.63v.125h.125v-.125zm0-1.829h.125v-.069l-.059-.037-.066.106zm-1.258-.783h-.125v.07l.06.036.065-.106zm0-.36V10.5h-.125v.125h.125zm-.568-.592l.771.686.166-.187-.771-.686-.166.187zm-.606.686l.772-.686-.166-.187-.772.686.166.187zm.146-.219H7.24v.25h.229v-.25zm-.125.125v.396h.25v-.396h-.25zm.059.29l-1.2.747.133.213 1.199-.748-.132-.212zm-1.258.853v1.829h.25v-1.829h-.25zm.125 1.704H6.04v.25h.229v-.25zm-.354.125v.342h.25v-.342h-.25zm.125.467h.229v-.25H6.04v.25zm.104-.125h.25-.25zm.125.126h3.485v-.25H6.27v.25zm3.61-.125h-.25.25zm-.125.124h.286v-.25h-.286v.25zm.411-.125v-.342h-.25v.342h.25zm-.125-.467h-.286v.25h.286v-.25zm-.16.125v-1.829h-.25v1.829h.25zm-.06-1.935l-1.258-.783-.132.212 1.258.784.132-.213zm-1.199-.677v-.36h-.25v.36h.25zm.161-.485h-.286v.25h.286v-.25z",
      fill: "#3B3B3B"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.951 17.02c1.061 0 1.792-.115 2.168-.313a.505.505 0 01.456-.255c.826.03 1.466-.318 1.97-1.083.543-.827.652-2.002.298-3.543l.9-.207c.405 1.767.273 3.192-.427 4.257-.628.954-1.484 1.464-2.528 1.499-.533.395-1.468.569-2.837.569-1.324 0-2.305-.258-2.935-.804-1.43-.338-2.339-.908-2.696-1.753-.38-.901-.38-2.152-.025-3.764l.901.199c-.318 1.442-.318 2.514-.026 3.205.204.483.797.877 1.801 1.15l.933.2-.045.235c.455.266 1.15.408 2.092.408z",
      fill: "#FBCD17"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.767 9.176a.5.5 0 00.277.65l.016.007-.024.05a.502.502 0 00.478.718l-.011.056c-.103.505.479.757.8.5a.48.48 0 00.47-.385l.056-.24.023.007c.472.142.79-.378.582-.73a.499.499 0 00-.584-.719l-.516.158a.487.487 0 00-.217-.01.498.498 0 00-.188-.134L5.417 8.9a.5.5 0 00-.65.277zm2.062 1.356l.122-.518-.63.364.508.154z",
      fill: "#73BE4A"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.205 10.476a.5.5 0 100-1 .5.5 0 000 1z",
      fill: "#FBCD17"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.239 10.073c-.008-.337-.046-1.104-.216-1.104-.172 0-.198.777-.201 1.11-.295.097-.517.35-.517.35h1.471s-.232-.265-.537-.356z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M2.55 12.568l.247.043c-.2 1.146-.2 1.968-.007 2.458.224.57 1.546 1.336 1.92 1.336v.25c-.47 0-1.888-.82-2.153-1.494-.213-.543-.213-1.405-.006-2.593zM13.38 12.509l-.247.041c.18 1.075.14 1.914-.116 2.516-.31.725-1.502 1.649-1.815 1.649v.25c.421 0 1.7-.99 2.045-1.801.278-.652.32-1.537.133-2.655zM6.393 17.424l.047-.245c.796.152 1.34.229 1.625.229.285 0 .8-.076 1.539-.229l.05.245c-.755.156-1.282.234-1.588.234-.306 0-.862-.078-1.673-.234z",
      fill: "#73BE4A"
    }
  )))
), h = v;
export {
  h as default
};
